// extracted by mini-css-extract-plugin
export var readonly = "_i0-1";
export var star = "_i0-0";